import JavaScript from "./ReviewImage/JavaScript.png";
import Python from "./ReviewImage/python.jpg";
import cLan from "./ReviewImage/cLan.jpg";
import java from "./ReviewImage/java.jpg";
export const ReviewData = [
    {
      id: 1,
      image:
        JavaScript,
      name: 'JavaScript',
      title: 'JavaScript job Title',
      quote:
        'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Expedita, hic minus? Sit qui doloribus voluptatem nisi fugit eum nesciunt laborum praesentium error voluptatum sapiente veniam sed officiis aut, tempora consectetur?',
      linkedin:"#"
    },
    {
      id: 2,
      image:
        Python,
      name: 'Python',
      title: 'Python job Title',
      quote:
        'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Expedita, hic minus? Sit qui doloribus voluptatem nisi fugit eum nesciunt laborum praesentium error voluptatum sapiente veniam sed officiis aut, tempora consectetur?',
      linkedin:"#"
    },
    {
      id: 3,
      image:
        java,
      name: 'Java',
      title: 'Java job title',
      quote:
        'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Expedita, hic minus? Sit qui doloribus voluptatem nisi fugit eum nesciunt laborum praesentium error voluptatum sapiente veniam sed officiis aut, tempora consectetur?',
      linkedin:"#"
    },
    {
      id: 4,
      image:
        cLan,
      name: 'C & C++',
      title: 'C job title',
      quote:
        'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Expedita, hic minus? Sit qui doloribus voluptatem nisi fugit eum nesciunt laborum praesentium error voluptatum sapiente veniam sed officiis aut, tempora consectetur? ',
      linkedin:"#"
    },
  ];